/**
 * The rim cluster (doc 14) — a shoal as the player meets it, before it is a
 * shoal.
 *
 * This is deliberately NOT a creature. Out on the rim there are no animals yet:
 * there is a knot of cold lights circling in the dark, and the only information
 * it carries is how many stars of menace it is worth and whether it has noticed
 * you. Drawing recognisable fish here would answer the question the LURE & REEL
 * loop exists to ask — *what is in that one?* — before the player pulls it.
 *
 * Lived in `creatures.ts` until stage 7a retired that file.
 */

import { signatureRamp, type DepthPalette } from '../render/palette.ts';
import { PixelSurface } from '../render/surface.ts';

export function drawShoalCluster(
  depth: DepthPalette,
  menace: number,
  riled: boolean,
  pulse: number,
): PixelSurface {
  const s = new PixelSurface(26, 18);
  const g = signatureRamp(depth.enemyGlow);
  // Riled is the light going hot, exactly as it is on the animals themselves
  // (`glowStep`): one vocabulary for "it has noticed you", used everywhere.
  const glow = riled ? g.hot : g.on;
  const dim = g.dim;
  // one dot per menace star, huddled; the pulse breathes them
  const spots: Array<[number, number]> = [
    [13, 9],
    [8, 6],
    [18, 7],
    [10, 12],
    [17, 12],
  ];
  for (let k = 0; k < Math.min(menace, spots.length); k++) {
    const [x, y] = spots[k]!;
    const hot = (k + pulse) % 2 === 0;
    s.px(x, y, hot ? glow : dim, 'set');
    if (hot) {
      s.px(x - 1, y, dim);
      s.px(x + 1, y, dim);
      s.px(x, y - 1, dim);
      s.px(x, y + 1, dim);
    }
  }
  return s.resetOps();
}
